import { useContext, useState } from "react";

import { ID_PAY_PRICING } from "shared/config/pricings";
import DocumentIllustration from "components/DocumentIllustration";
import ResultAfterPayment from "components/ResultAfterPayment";
import { StripePaymentCard } from "features/payment";
import { UserContext } from "features/account";
import IDPayStepperMenu from "./components/IDPayStepperMenu";
import IDPayInfoForm from "./components/IDPayInfoForm";
import { useNavigate } from "react-router-dom";

export default function IDPayAdd() {
    const navigate = useNavigate();

    const { user, userType } = useContext(UserContext);
    const [message, setMessage] = useState("");
    const [title, setTitle] = useState("");
    const [paymentSucceeded, setPaymentSucceeded] = useState(false);
    const [datas, setDatas] = useState<any>({
        user: user,
        email: "",
        firstName: "",
        lastName: "",
        phoneNumber: "",
        chosenPlan: ID_PAY_PRICING[0],
    });

    const [steps, setSteps] = useState([
        { isCurrent: true, isDone: false },
        { isCurrent: false, isDone: false },
        { isCurrent: false, isDone: false },
    ]);

    const handleUpdateStep = (step: number) => {
        setSteps(
            steps.map((s, index) => {
                if (index === step) {
                    return { isCurrent: true, isDone: false };
                } else if (index < step) {
                    return { isCurrent: false, isDone: true };
                }
                return { isCurrent: false, isDone: false };
            }),
        );
    };

    const handleNextStep = () => {
        const currentStep = steps.findIndex((step) => step.isCurrent);
        if (currentStep < steps.length - 1) {
            handleUpdateStep(currentStep + 1);
        }
    };

    const handlePreviousStep = () => {
        const currentStep = steps.findIndex((step) => step.isCurrent);
        if (currentStep > 0) {
            handleUpdateStep(currentStep - 1);
        } else {
            navigate(`${user?.type === 'partner' ? '/professionnels' : '/particuliers'}/id-pay/dashboard`);
        }

    };

    const handlePaymentResult = (title: string, message: string, paymentSucceeded: boolean) => {
        handleNextStep();
        setTitle(title);
        setMessage(message);
        setPaymentSucceeded(paymentSucceeded);
        if (paymentSucceeded) {

        }
    };

    return (
        <div className="IDPayAdd h-100">
            <div className="content__body h-100">
                <div className="row">
                    <div className="col-sm-1">
                        <IDPayStepperMenu
                            steps={steps}
                            setSteps={setSteps}
                            handleUpdateStep={handleUpdateStep}
                        />
                    </div>
                    <div className={`col-sm-6`}>
                        <div className="content--card">
                            {steps[0].isCurrent && (
                                <IDPayInfoForm
                                    setDatas={setDatas}
                                    datas={datas}
                                    steps={steps}
                                    handleNextStep={handleNextStep}
                                    handlePreviousStep={handlePreviousStep}
                                />
                            )}
                            {steps[1].isCurrent && (
                                <StripePaymentCard
                                    title={`Vérification`}
                                    link={`${user?.type === 'partner' ? '/professionnels' : '/particuliers'}/id-pay/dashboard`}
                                    setDatas={setDatas}
                                    datas={datas}
                                    steps={steps}
                                    handlePaymentResult={handlePaymentResult}
                                    handlePreviousStep={handlePreviousStep}
                                />
                            )}
                            {steps[2].isCurrent && (
                                <ResultAfterPayment
                                    title={title}
                                    message={message}
                                    pageSucceeded={paymentSucceeded}
                                    steps={steps}
                                    handlePreviousStep={handlePreviousStep}
                                    handleNextStep={() => (window.location.href = `${user?.type === 'partner' ? '/professionnels' : '/particuliers'}/id-pay/dashboard`)}
                                    textBtn={"Accéder à ID Pay"}
                                />
                            )}
                        </div>
                    </div>
                    <div className={`col-sm-5 center`}>
                        <div>
                            {/*<h3 className="text-center mb-4">Remplir mon dossier d'accompagnement</h3>*/}
                            <DocumentIllustration type={"payment"} />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}
